<template>
  <el-dropdown @command="handleCommand">
    <span class="el-dropdown-link">
      {{ $t("message.aboutMsg")
      }}<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh">{{ $t("message.zh") }}</el-dropdown-item>
      <el-dropdown-item command="en">{{ $t("message.en") }}</el-dropdown-item>
      <el-dropdown-item command="italian">{{ $t("message.italian") }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  data: () => ({
    msg: "message.about",
    lang: "zh",
  }),
  watch: {
    lang(newValue) {
      this.$i18n.locale = newValue; //通过改变this.$i18n的值来改变当前语言
    },
  },
  mounted() {},
  methods: {
    handleCommand(command) {
      this.$i18n.locale = command;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/LangToggle/index.vue